import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/icons/scan_outline.svg'


const _hoisted_1 = { class: "home-layout-footer" }
const _hoisted_2 = { class: "tab-list" }
const _hoisted_3 = { class: "tab-name" }
const _hoisted_4 = { class: "tab-name" }
const _hoisted_5 = { class: "tab-name" }
const _hoisted_6 = { class: "tab-name" }
const _hoisted_7 = { class: "tab-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nft_app_svg = _resolveComponent("nft-app-svg")!
  const _component_search_svg = _resolveComponent("search-svg")!
  const _component_ticket_svg = _resolveComponent("ticket-svg")!
  const _component_profile_svg = _resolveComponent("profile-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["tab-item", _ctx.selectClass(_ctx.$route.name, 'nft')]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleTab('nft')))
      }, [
        _createVNode(_component_nft_app_svg),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("footerMenu.nft")), 1)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["tab-item", _ctx.selectClass(_ctx.$route.name, 'search')]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => ([_ctx.toggleTab('search'), _ctx.initSearch()]))
      }, [
        _createVNode(_component_search_svg, { class: "search-svg" }),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("footerMenu.search")), 1)
      ], 2),
      _createElementVNode("div", {
        class: "tab-item scan-tab",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'QrScanView' })))
      }, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "scan-button" }, [
          _createElementVNode("img", { src: _imports_0 })
        ], -1)),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("footerMenu.scan")), 1)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["tab-item", _ctx.selectClass(_ctx.$route.name, 'coupon')]),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleTab('coupon')))
      }, [
        _createVNode(_component_ticket_svg, { class: "coupon-svg" }),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("footerMenu.coupon")), 1)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["tab-item", _ctx.selectClass(_ctx.$route.name, 'profile')]),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleTab('profile')))
      }, [
        _createVNode(_component_profile_svg, { class: "profile-svg" }),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("footerMenu.profile")), 1)
      ], 2)
    ])
  ]))
}